module.exports = __webpack_public_path__ + "static/media/bulb.facea4b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/StatsBox/img/bulb.svg
// module id = 172
// module chunks = 0